<template lang="pug">
  .branding
    .col1
      Logo(:brand="brand")
    .col2
      transition(name="top-fade" mode="out-in")
        .translogo.withlogo(v-if="config.logo" key="bla")
          Logo(:brand="special")
          .wrap-sponsor
            span Presentado por
            Logo(:brand="sponsors.first")
            span Auspiciado por
            Logo(:brand="sponsors.second")
        .translogo(v-if="!config.logo" key="blo")
          .wrap-sponsor
            span Presentado por
            Logo(:brand="sponsors.first")
            span Auspiciado por
            Logo(:brand="sponsors.second")
    //- .col3.in
    //-   router-link(:to="{name: 'home'}")
    //-   Logo(:brand="lab")

</template>
<script>
import { mapState, mapActions } from 'vuex'
import Logo from '@/components/Logo'
import MenuButton from '@/components/MenuButton'

export default {
  data(){
    return {
      menuactive: false,
    }
  },
  components: {
    Logo,
    MenuButton
  },
  props: {
    brand: {
      type: Object
    },
    sponsors: {
      type: Object
    },
    lab: {
      type: Object
    },
    special: {
      type: Object
    },
  },
  computed: {
    ...mapState([
      'config'
    ])
  },
  created(){
    this.setLogoFunc(this.$route)
  },
  watch:{
    $route(to, from){
      this.setLogoFunc(to)
    }
  },
  methods: {
    ...mapActions([
      'toggleMenu',
      'setLogo'
    ]),
    setLogoFunc(route){
      if(route.name === 'home'){
        this.setLogo(false)
      } else {
        this.setLogo(true)
      }
    },
  }
}
</script>
<style lang="scss" scoped>
  .in{
    display: flex;
  }
  .menubutton{
    position: relative;
    z-index: 11;
  }
  .wrap-sponsor{
    display: flex;
    align-items: center;
  }
  .translogo{
    display: flex;
    align-items: center;
    justify-content: center;

  }
  .withlogo{
    .wrap-sponsor{
      padding-left: 20px;
    }
  }
  .branding{
    display: grid;
    align-items: flex-start;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 1rem;
    padding: 1rem;
    font-family: 'Open Sans', sans-serif;
    position: relative;
    color: white;
    max-width: 100vw;

    .col1{
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .col2{
      display: flex;
      justify-content: flex-end;
      align-items: center;
      @media(max-width: 800px){
        justify-content: flex-start;
      }
      span{
        @media (max-width: 800px){
          font-size: 10px;
        }
      }
    }
     @media (max-width: 800px){
      grid-template-columns: 1fr;
      .col1{
        display: none;
      }
      .col2{
        display: flex;
        justify-content: center;
      }
    }
    // .col3{
    //   display: flex;
    //   justify-content: flex-end;
    //   align-items: center;
    // }

    &:before{
      content: '';
      left: 0;
      right: 0;
      top: 0;
      position: absolute;
      z-index: -1;
      height: 10vh;
      background: linear-gradient(rgba(black, 0.6), transparent );
    }
    span{
      font-size: 12px;
      line-height: 12px;
      padding-right: 2px;
      text-align: right;
    }
  }
</style>
